import React, { useState, useEffect } from 'react'
import { XIcon } from '@heroicons/react/solid'
import LineItem from '@molecules/LineItem/LineItem'
import CommerceBox from '@organisms/CommerceBox/CommerceBox'

import * as T from './MiniCart.types'
import { BonusDiscountLineItem } from '@molecules/LineItem/LineItemPromotion.types'

const MiniCartProductDisplay = ({
  fullProduct,
  fallBackImage,
  productUrlBuilder,
  buildUrl,
  onDelete,
  onQuantityChange,
  removePromoCode,
  handleBonusDiscountLineItem = () => {},
  bonusItemsByCouponCode = new Map<string, BonusDiscountLineItem>(),
  couponItems,
  inline = false,
  WishlistButton
}: T.MiniCartProductDisplayProps) => {
  const {
    id,
    image,
    productId,
    itemId,
    c_image,
    productName,
    c_promotionMessage,
    c_servings,
    currency,
    priceAfterItemDiscount,
    priceAdjustments,
    shortDescription,
    c_shortDescription,
    c_purchasable
  } = fullProduct || {}
  const { ats, orderable, preorderable, stockLevel, inStockDate } =
    (fullProduct || {}).c_inventory || {}

  return (
    <LineItem
      id={itemId}
      fallBackImage={fallBackImage}
      productUrl={buildUrl(
        productUrlBuilder({
          id: productId || id,
          name: productName
        })
      )}
      productDescription={
        c_servings || shortDescription || c_shortDescription || ''
      }
      productPromotionMessage={c_promotionMessage}
      priceAdjustments={priceAdjustments}
      priceAfterItemDiscount={priceAfterItemDiscount}
      removePromoCode={removePromoCode}
      handleBonusDiscountLineItem={handleBonusDiscountLineItem}
      bonusItemsByCouponCode={bonusItemsByCouponCode}
      couponItems={couponItems}
      currency={currency}
      productName={productName}
      purchasable={c_purchasable}
      thumbnailUrl={c_image || image?.disBaseLink || fallBackImage}
      inventory={{ ats, orderable, preorderable, stockLevel, inStockDate }}
      inline={inline}
      commerceBox={
        <CommerceBox
          CTAButton={<XIcon className='h-5 w-5' />}
          type={'miniCart'}
          onDelete={onDelete}
          onQuantityChange={onQuantityChange}
          product={fullProduct}
          WishlistButton={WishlistButton}
        />
      }
    />
  )
}

const MiniCartProduct = ({
  product,
  fallBackImage,
  getProductDetail,
  productUrlBuilder,
  buildUrl,
  onDelete,
  onQuantityChange,
  removePromoCode = () => {},
  handleBonusDiscountLineItem = () => {},
  bonusItemsByCouponCode = new Map<string, BonusDiscountLineItem>(),
  couponItems,
  inline = false,
  WishlistButton
}: T.MiniCartProductProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const [productDetails, setProductDetails] = useState({
    inventory: product.c_inventory
  })

  useEffect(() => {
    if (!productDetails?.inventory) {
      getProductDetail(product.productId).then((data: any) => {
        setProductDetails(data)
      })
    }
  }, [])

  useEffect(() => {
    setIsLoading(false)
  }, [productDetails?.inventory])

  return (
    <>
      {!isLoading && (
        <MiniCartProductDisplay
          fallBackImage={fallBackImage}
          buildUrl={buildUrl}
          onDelete={onDelete}
          onQuantityChange={onQuantityChange}
          removePromoCode={removePromoCode}
          handleBonusDiscountLineItem={handleBonusDiscountLineItem}
          bonusItemsByCouponCode={bonusItemsByCouponCode}
          couponItems={couponItems}
          inline={inline}
          productUrlBuilder={productUrlBuilder}
          fullProduct={{ ...productDetails, ...product }}
          WishlistButton={WishlistButton}
        />
      )}
    </>
  )
}

export default MiniCartProduct
